// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import ProfileContainer from 'modules/onBoarding/components/Profile'

const Profile = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 1 - Profile Settings & Bio | ATD`}>
      <ProfileContainer />
    </DocumentTitle>
  )
}

export default Profile
